import React from "react";

const TagAdv = ({
  title,
  size = "md",
  variant = "contained", // contained, outlined, text
  color = "primary", // primary, warning, success, danger, gray
  colorDepth = 600, // 50,100,200,300,400,500, 600, 700, 800, 900
  className = "",
}) => {
  const sizeStyles = {
    xs: "text-[9px] leading-none p-1",
    "xs-sm": "text-[10px] leading-none p-1",
    sm: "text-[12px] leading-none p-2",
    md: "text-[14px] leading-none p-2",
    lg: "text-[16px] leading-none p-2",
    xl: "text-[18px] leading-none  p-2",
  };

  const getVariantClasses = () => {
    const baseClasses = {
      contained: `border border-${color}-100 bg-${color}-50 text-${color}-${colorDepth}`,
      outlined: `border border-${color}-100 text-${color}-${colorDepth}`,
      text: `border border-transparent text-${color}-${colorDepth}`,
    };

    // Only add hover classes if not disabled
    return `${baseClasses[variant]}`;
  };
  const defaultClassName = "rounded text-nowrap";
  const mergedClassName = `${defaultClassName} ${className}`;

  return (
    <div
      className={`${
        sizeStyles[size]
      } ${mergedClassName}  ${getVariantClasses()}`}
    >
      {title}
    </div>
  );
};

export default TagAdv;
